import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SessionTimeoutWarningComponent } from './session-timeout-warning/session-timeout-warning.component';
import { HospitalSiteSelectorComponent } from './hospital-site-selector/hospital-site-selector.component';

@NgModule({
  declarations: [
    SessionTimeoutWarningComponent,
    HospitalSiteSelectorComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    SessionTimeoutWarningComponent,
    HospitalSiteSelectorComponent
  ]
})
export class SharedModalsModule { }
